export default "__VITE_ASSET__56c9e097__"